import React from "react";
import { Box, DialogTitle, IconButton, Typography } from "@material-ui/core";
import { alpha, makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(2.5, 3, 2),
    position: "relative",
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
    color: theme.palette.text.primary,
    flex: 1,
  },
  icon: {
    ...theme.neoUI?.buttons?.action?.root,
    width: 40,
    height: 40,
    borderRadius: theme.shape.borderRadius,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(2),
    padding: 0,
    "&:hover": {
      ...theme.neoUI?.buttons?.action?.root?.["&:hover"],
    },
  },
  closeButton: {
    position: "absolute",
    top: 10,
    right: 10,
    color: theme.palette.text.secondary,
    background: alpha(theme.palette.divider, 0.05),
    "&:hover": {
      background: alpha(theme.palette.divider, 0.1),
    },
  },
}));

const DialogHeader = ({ id, icon, title, onClose, closeLabel = "Fechar" }) => {
  const classes = useStyles();

  return (
    <DialogTitle id={id} disableTypography className={classes.root}>
      {icon ? <Box className={classes.icon}>{icon}</Box> : null}
      <Typography className={classes.title}>{title}</Typography>
      {onClose ? (
        <IconButton
          className={classes.closeButton}
          onClick={onClose}
          size="small"
          aria-label={closeLabel}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

export default DialogHeader;
